import { ITypedReduxAction } from '../../../types/redux/actionType';
import { ISettings } from '../../../types/settings';

export enum ESetCurrentLayoutActionType {
  Set = 'settings/setCurrentLayout',
}

export type TSetCurrentLayout = ITypedReduxAction<ESetCurrentLayoutActionType.Set, ISettings['currentLayout']>;
